var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOpEstimate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.134,
    height: 20,
    viewBox: "0 0 20.134 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12488",
    "data-name": "Group 12488",
    transform: "translate(-1085.955 -869.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12437",
    "data-name": "Group 12437",
    transform: "translate(783.705 -46.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12490",
    "data-name": "Group 12490",
    transform: "translate(0 392)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2970",
    "data-name": "Rectangle 2970",
    width: 20.134,
    height: 20,
    rx: 10,
    transform: "translate(302.25 524.5)",
    fill: "#4a90f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_rotate_90_degrees_ccw_24px",
    d: "M4.673,4.085.86,7.9l3.819,3.813L8.5,7.9ZM2.525,7.9,4.679,5.75,6.827,7.9,4.673,10.058ZM11.747,4.22A5.267,5.267,0,0,0,8,2.667V.76l-2.5,2.5L8,5.75V3.844a4.12,4.12,0,1,1-1.671,7.88l-.877.877a5.292,5.292,0,0,0,6.291-8.38Z",
    transform: "translate(304.42 526.99)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpEstimate);
export default __webpack_public_path__ + "static/media/op-estimate.cfc41c351452d0a77985f90329007d5c.svg";
export { ForwardRef as ReactComponent };